import { QueryClient } from '@tanstack/react-query';

// Eén QueryClient per router (dus per request op de server), zie getRouter().
export function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1000 * 60,
        gcTime: 1000 * 60 * 5,
        refetchOnWindowFocus: false,
      },
    },
  });
}
